import { Injectable } from '@angular/core';

import { ExpedicaoSearch } from '../expedicao-search';

@Injectable({
    providedIn: 'root'
})
export class ExpedicaoUtilsService {

    /** Calcula a quantidade de volumes previstos dos pedidos em expedição informados */
    calcularQuantidadeVolumesPrevistos(entities: ExpedicaoSearch[]): number {
        if (!entities) {
            return 0;
        }

        let quantidade = 0;
        entities.forEach(entity => {
            quantidade += entity.quantidadeVolumesPrevistos ? Number(entity.quantidadeVolumesPrevistos) : 0;
        });

        return quantidade;
    }

    /** Calcula a quantidade de volumes efetivos dos pedidos em expedição informados */
    calcularQuantidadeVolumesEfetivos(entities: ExpedicaoSearch[]): number {
        if (!entities) {
            return 0;
        }

        let quantidade = 0;
        entities.forEach(entity => {
            quantidade += entity.quantidadeVolumesEfetivos ? Number(entity.quantidadeVolumesEfetivos) : 0;
        });

        return quantidade;
    }
}
